@if (Note) {
  <div class="modal-header">
    <h3 class="mb-0">Email</h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="email-body pe-none" [innerHTML]="Note.note"></div>
  </div>

  <div class="modal-footer">
    <div class="action-row justify-end w-100">
      <button type="button" class="btn btn-primary" (click)="close()">
        Close
      </button>
    </div>
  </div>
}
